import { ReactNode } from 'react';

import styles from '@components/cards/AccountCard.module.css';

type Props = {
  background?: 'neutral50';
  boxShadow?: boolean;
  children: ReactNode;
  hover?: boolean;
  padding?: 'small' | 'normal';
};

const AccountCard = ({ background, boxShadow = false, children, hover = true, padding = 'normal' }: Props) => (
  <div
    className={`${styles.card} ${boxShadow ? styles.cardBoxShadow : ''} ${
      padding === 'small' ? styles.cardSmallPadding : ''
    } ${styles[background ?? '']} ${hover ? styles.cardHover : ''}`}
  >
    {children}
  </div>
);

export default AccountCard;
